import React from 'react';
import Menusidebar from '../components/Element/Menusidebar';
//import Profilesidebar from '../components/Element/Profilesidebar';
import EmailVerifcation from '../components/Element/Email_Verifcation';
const EmailVerification = (props) => {
	return (
		<React.Fragment>
			<div className="page-content bg-white">
				<div className="content-block">
					<div className="section-full bg-white browse-job p-t50 p-b20">
						<div className="container">
							<div className="row">
								{<Menusidebar page="timesheet"/>}
								{/*<div className="col-xl-9 col-lg-8 m-b30"> */}
								
								<div className="col-xl-9 col-lg-8 m-b30">
									<EmailVerifcation />
								</div>
								
								
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

export default EmailVerification;